import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import ReferenceTable from "../../../components/ReferenceTables/ReferenceTable";

const ReferenceTablePage: React.FC = () => {
  const { schema, table } = useParams<{ schema: string; table: string }>();
  const { t } = useTranslation();

  if (!schema || !table) {
    return (
      <Paper sx={{ width: "100%", p: 2}}>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" color="error">
            {t("admin.reference.generic.invalid-schema-or-table")}
          </Typography>
        </Box>
      </Paper>
    );
  }

  return <ReferenceTable schema={schema} table={table} />;
};

export default ReferenceTablePage;